import React from 'react'

const Image = (props) => {
  const {
    errorPlaceholder,
    ...localProps
  } = props
  return (
    <img
      draggable="false"
      alt=""
      onError={(e) => {
        e.target.onerror = null
        e.target.src=errorPlaceholder
      }}
      {...localProps}
    >
      {props.children}
    </img>
  )
}

export default Image



// WEBPACK FOOTER //
// ./src/components/shared/image.js